import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../../../AnimationContents';
import { ButtonController } from '../../../Common/ButtonController';
import { GameLogic } from '../../../Logic/GameLogic';
import { GameModel } from '../../../Models/GameModel';

export interface ITaskListScreenControllerOptions {}

export class TaskListScreenController extends AnimationBaseController {
    public $model: GameModel;

    private _taskWidth: number = 0;
    private _taskHeight: number = 0;

    public constructor(
        @Inject private _options: ITaskListScreenControllerOptions,
        @Inject private _gameLogic: GameLogic
    ) {
        super('TaskListScreenController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.TASK_LIST_SCREEN_JSON,
            libraryName: 'task_list',
            childControllers: {
                button_exit: {
                    instanceName: 'btn_exit',
                    controller: ButtonController,
                    model: this.$model,
                    options: {
                        onClick: () => {
                            this._gameLogic.hideTaskScreen();
                        },
                    },
                },
            },
        };
    }

    protected onInitialize(): void {
        this._taskWidth = 1920;//this.width;
        this._taskHeight = 1440;//this.height;
        
        this.$model.doneMiniGames.forEach(item => {
            this.gotoAndStopByQuery(item, 'done');
        });
    }

    protected onResize(width: number, height: number, scale: number) {
        const scaleValue = Math.min(
            width / scale / this._taskWidth,
            height / scale / this._taskHeight,
        );

        this.scaleX = scaleValue;
        this.scaleY = scaleValue;
    }
}
